import React, { useEffect, useContext, useState } from 'react';
import '../CommonStyle.css';
import { GlobalContext } from '../../../store/Store';
import Checkbox from '@mui/material/Checkbox';
import BoundaryLine from '../../../icons/BoundaryLine.svg?react'
import More from '../../../icons/More.svg?react'
import  ActionType from '../../../store/ActionType';
import { ModelType } from '../../../Models/Mesh';
import TextField from '@mui/material/TextField';
import MikeButton from '../../mike-button';
import { MikeSwitch } from '../SwitchControl';
import ProviderDialog from '../../ProviderDialog';
import ProviderIcon from '../../ProviderIcon';
import { SelectedData } from '../../app/AppWrapper';
import OlSelect from 'ol/interaction/Select';
import * as condition from 'ol/events/condition';
import Skeleton from '@mui/material/Skeleton';
import { CardHeader, Card, Tooltip, IconButton } from '@mui/material';
import { colors } from '../../map/MapFunctions';
import { Provider } from '../../../generated/src/models';
import TemporalDataCoverage from '../TemporalDataCoverage';
import { getProvider } from '../../utils';

export default function BoundarySelection() {
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const [expanded, setExpanded] = React.useState(false);
  const [expandedBoundaryProps, setExpandedBoundaryProps] = React.useState(false);

  const [editExtractionData, setEditExtractionData] = React.useState([]);
  const [editExtractionDataExpanded, setEditExtractionDataExpanded] = React.useState([]);

  const [provider, setProvider] = useState<Provider | undefined>();
  const openDialog = (value: Provider) => () => {
    setProvider(value);
  };
  const closeDialog = () => setProvider(undefined);

  const [selectInteraction, setSelectInteraction] = React.useState(null);

  useEffect(() => {
    if ((globalState.map as any).olMap) {
      const select = new OlSelect({ condition: condition.never });
      if (selectInteraction !== null) {
        (globalState.map as any).olMap.removeInteraction(selectInteraction);
      }
      setSelectInteraction(select);
      (globalState.map as any).olMap.addInteraction(select);
      globalState.data.selected = new SelectedData();
    }
  }, [globalState.mesh.features]);

  useEffect(() => {
    if (globalState.data.extractionbuilderdata) {
      globalState.data.extractionbuilderdata.boundaries.isExpanded = expanded;
      // Update GlobalState with the overwritten Object
      globalDispatch({
        type: ActionType.SET_DATA_EXTRACTION_BUILDER,
        data: globalState.data.extractionbuilderdata,
      });
    }
  }, [expanded]);

  useEffect(() => {
    // New Data Close the panel
    setExpandedBoundaryProps(false);
    setExpanded(false);
  }, [globalState.data.extractionbuilderdata]);

  const updateGlobalCount = (count: number, expanded: boolean) => {
    if (!globalState.data.selected) {
      globalState.data.selected = new SelectedData();
    }
    const _state = globalState.data.selected;
    if (expanded){
      _state.ExpBoundaryConditions = _state.ExpBoundaryConditions + count
    }
    else{
      _state.BoundaryConditions = _state.BoundaryConditions + count
    }   
    globalState.data.selected = _state;
  };

  const updateField = (parentIndex: number, childIndex: number) => e => {
    updateGlobalCount(e.target.checked ? 1 : -1, expanded);
    if (expanded === true) {
      globalState.data.extractionbuilderdata.boundaries.boundariesExpanded.boundariesExpandedItems[
        parentIndex
      ].providers[childIndex].selected = e.target.checked;
      globalDispatch({
        type: ActionType.SET_DATA_EXTRACTION_BUILDER,
        data: globalState.data.extractionbuilderdata,
      });
    } else {
      globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed.providersCollapsed[
        childIndex
      ].selected = e.target.checked;
      globalDispatch({
        type: ActionType.SET_DATA_EXTRACTION_BUILDER,
        data: globalState.data.extractionbuilderdata,
      });
    }
  };

  const cancelUpdateExtractionData = () => {
    setTimeout(() => {
      setEditExtractionData([]);
    }, 500);
  };

  const updateExtractionData = () => {
    globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed.boundaryCollapsedItems = editExtractionData;
    globalState.data.extractionbuilderdata.boundaries.boundariesExpanded.boundariesExpandedItems = editExtractionDataExpanded;
  };

  const updateEditExtractionData = (itemName: string, childIndex: number, value: number) => {
    editExtractionData[childIndex][itemName] = value;
    editExtractionDataExpanded[childIndex][itemName] = value;
  };

  const editBoundariesProperty = () => {
    setEditExtractionData(
      JSON.parse(
        JSON.stringify(
          globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed
            .boundaryCollapsedItems
        )
      )
    );
    setEditExtractionDataExpanded(
      JSON.parse(
        JSON.stringify(
          globalState.data.extractionbuilderdata.boundaries.boundariesExpanded
            .boundariesExpandedItems
        )
      )
    );
    setExpandedBoundaryProps(!expandedBoundaryProps);
  };

  const highlightBoundaryEnter = item => {
    const features = globalState.mesh.features;

    for (let i = 0; i < features.length; i++) {
      if (parseInt(features[i].get('code')) === item.code) {
        features[i].set('Selected', true);
        selectInteraction.getFeatures().push(features[i]);
      }
    }
  };
  const highlightBoundaryLeave = () => {
    selectInteraction.getFeatures().clear();
  };

  const SkeletonItem: React.FC = () => {
    const skeletonRows = [1, 2, 3, 4, 5, 6, 8, 9, 10, 11];
    return (
      <div style={{ overflow: 'hidden' }}>
        {skeletonRows.map((ind: number) => (
          <Card key={ind}>
            <CardHeader
              avatar={<Skeleton animation="wave" variant="circular" width={32} height={32} />}
              title={
                <Skeleton animation="wave" height={12} width="80%" style={{ marginBottom: 6 }} />
              }
              subheader={
                <Skeleton animation="wave" height={12} width="40%" style={{ marginBottom: 6 }} />
              }></CardHeader>
          </Card>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="panelItemHeader tooltipFix">
        Group selection
        <Tooltip title="Activate / de-activate grouping of boundary condition provider options">
          <MikeSwitch checked={!expanded} onChange={() => setExpanded(!expanded)} />
        </Tooltip>
      </div>

      <div className="scrollableContent">
        {globalState.data.extractionbuilderdata && !expanded ? (
          <div className="panelItemHeader2">
            Grouped items (
            {
              globalState.data.extractionbuilderdata.boundaries.boundariesExpanded
                .boundariesExpandedItems.length
            }
            )
          </div>
        ) : (
          ''
        )}

        {globalState.data && globalState.data.fetchingExtractionBuilderData ? (
          <SkeletonItem />
        ) : globalState.data.extractionbuilderdata && expanded ? (
          globalState.data.extractionbuilderdata.boundaries.boundariesExpanded.boundariesExpandedItems.map(
            (item, i) => {
              const itemColor = colors[item.code % colors.length];
              const Item = (
                <div
                  key={i}
                  className="panelItem itemBorder noPadding groupedStyle"
                  onMouseEnter={() => highlightBoundaryEnter(item)}
                  onMouseLeave={() => highlightBoundaryLeave()}>
                  <div className="panelItemIcon">
                    <BoundaryLine />
                    <div className="circle" style={{ backgroundColor: itemColor }}></div>
                  </div>

                  <div className="panelItemContent boundaryItem">
                    <div
                      className={
                        globalState.mesh.modelType === ModelType.MIKE3
                          ? 'panelItemContentTitleOneLine'
                          : 'panelItemContentTitle'
                      }>
                      {item.name}
                    </div>
                    {globalState.mesh.modelType !== ModelType.MIKE3 && (
                      <div className="panelItemContentText">
                        Horizontal resolution: {item.horRes === null ? 0 : item.horRes}
                      </div>
                    )}
                    {globalState.mesh.modelType === ModelType.MIKE21 && (
                      <>
                        <div className="panelItemContentText">
                          Integration depth: {item.maxDepth === null ? 0 : item.maxDepth} m
                        </div>
                      </>
                    )}

                    {globalState.mesh.modelType !== ModelType.MIKE3 && (
                      <div
                        className="panelItemMore"
                        onClick={() => {
                          editBoundariesProperty();
                        }}>
                        <Tooltip title="Boundary resolution settings">
                          <IconButton> <More /></IconButton>
                         
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>
              );
              const Providers = item.providers.map((item, j) => (
                <div key={j} className="panelItem itemBorder noPadding">
                  <div className="contentFlex">
                    <Checkbox
                      className="panelCheckbox"
                      checked={item.selected}
                      onChange={updateField(i, j)}
                      value={item.selected}
                      color="secondary"
                      inputProps={{
                        'aria-label': 'secondary checkbox',
                      }}
                    />
                    <div className="panelItemIcon">
                      <ProviderIcon onClick={openDialog(item)} provider={item} />
                    </div>
                    <div>
                      <div className="panelItemContent cursorPointer" onClick={openDialog(item)}>
                        {item.displayName}
                      </div>
                      <TemporalDataCoverage provider={getProvider(globalState, item.name)} />
                    </div>
                  </div>
                </div>
              ));
              return [Item, Providers];
            }
          )
        ) : (
          ''
        )}

        {globalState.data && globalState.data.fetchingExtractionBuilderData
          ? null
          : globalState.data.extractionbuilderdata && !expanded
          ? globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed.boundaryCollapsedItems.map(
              (item, i) => {
                const itemColor = colors[item.code % colors.length];
                const Item = (
                  <div
                    key={i}
                    className="panelItem itemBorder noPadding"
                    onMouseEnter={() => highlightBoundaryEnter(item)}
                    onMouseLeave={() => highlightBoundaryLeave()}>
                    <div className="panelItemIcon">
                      <BoundaryLine />
                      <div className="circle" style={{ backgroundColor: itemColor }}></div>
                    </div>

                    <div className="panelItemContent boundaryItem">
                      <div
                        className={
                          globalState.mesh.modelType === ModelType.MIKE3
                            ? 'panelItemContentTitleOneLine'
                            : 'panelItemContentTitle'
                        }>
                        {item.name}
                      </div>
                      {globalState.mesh.modelType !== ModelType.MIKE3 && (
                        <div className="panelItemContentText">
                          Horizontal resolution: {item.horRes === null ? 0 : item.horRes}
                        </div>
                      )}
                      {globalState.mesh.modelType === ModelType.MIKE21 && (
                        <>
                          <div className="panelItemContentText">
                            Integration depth: {item.maxDepth === null ? 0 : item.maxDepth} m
                          </div>
                        </>
                      )}
                      {globalState.mesh.modelType !== ModelType.MIKE3 && (
                        <div
                          className="panelItemMore"
                          onClick={() => {
                            editBoundariesProperty();
                          }}>
                          <Tooltip title="Boundary resolution settings">
                            <IconButton> <More /></IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  </div>
                );
                return Item;
              }
            )
          : ''}
        {globalState.data && globalState.data.fetchingExtractionBuilderData
          ? null
          : globalState.data.extractionbuilderdata && !expanded
          ? globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed.providersCollapsed.map(
              (item, i) => {
                const Providers = (
                  <div key={i} className="panelItem itemBorder noPadding">
                    <div className="contentFlex">
                      <Checkbox
                        className="panelCheckbox"
                        checked={item.selected}
                        onChange={updateField(0, i)}
                        value={item.selected}
                        color="secondary"
                        inputProps={{
                          'aria-label': 'secondary checkbox',
                        }}
                      />
                      <div className="panelItemIcon">
                        <ProviderIcon onClick={openDialog(item)} provider={item} />
                      </div>
                      <div>
                        <div className="panelItemContent cursorPointer" onClick={openDialog(item)}>
                          {item.displayName}
                        </div>
                        <TemporalDataCoverage provider={getProvider(globalState, item.name)} />
                      </div>
                    </div>
                  </div>
                );
                return Providers;
              }
            )
          : ''}
      </div>

      <div
        className={expandedBoundaryProps ? 'boundaryPropertyPanel' : 'hideBoundaryPropertyPanel'}>
        <h5>Boundary resolution definition</h5>
        <div className="boundaryPropertyContainer scrollableContent">
          <div className="boundaryPropertyItems">
            {editExtractionData.map((item, i) => {
              const itemColor = colors[item.code % colors.length];
              const Items = (
                <div key={i} className="panelItem itemBorder noPadding">
                  <div className="panelItemIcon">
                    <BoundaryLine />
                    <div className="circle" style={{ backgroundColor: itemColor }}></div>
                  </div>

                  <div className="panelItemContent">
                    <div className="panelItemContentTitle">{item.name}</div>
                    <div className="panelItemContentText">
                      <TextField
                        className="boundaryPropertyItem"
                        style={{ width: 110 }}
                        id="standard-basic"
                        label="Horizontal"
                        type="number"
                        slotProps={{inputLabel: {shrink: true}}}
                        onChange={e => {
                          updateEditExtractionData('horRes', i, +e.target.value);
                        }}
                        defaultValue={item.horRes === null ? 0 : item.horRes}
                      />
                      {globalState.mesh.modelType === ModelType.MIKE21 && (
                        <>
                          {/* This Is hidden for det time being */}
                          {/* <TextField
                            className="boundaryPropertyItem"
                            style={{ width: 60 }}
                            id="standard-basic"
                            label="Vertical"
                            type="number"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={e => {
                              updateEditExtractionData('verRes', i, +e.target.value);
                            }}
                            defaultValue={item.verRes === null ? 0 : item.verRes}
                          /> */}
                          <TextField
                            className="boundaryPropertyItem"
                            style={{ width: 110 }}
                            id="standard-basic"
                            label="Integration depth (m)"
                            type="number"
                            slotProps={{inputLabel: {shrink: true}}}
                            onChange={e => {
                              updateEditExtractionData('maxDepth', i, +e.target.value);
                            }}
                            defaultValue={item.maxDepth === null ? 0 : item.maxDepth}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
              return Items;
            })}
          </div>
        </div>

        <div className="boundaryPropertyButtons">
          <MikeButton
            variant="outlined"
            color="secondary"
            onClick={() => {
              setExpandedBoundaryProps(!expandedBoundaryProps); cancelUpdateExtractionData();
            }}>
            Cancel
          </MikeButton>
          <MikeButton
            variant="contained"
            color="secondary"
            onClick={() => {
              setExpandedBoundaryProps(!expandedBoundaryProps); updateExtractionData();
            }}>
            Confirm values
          </MikeButton>
        </div>
      </div>

      <ProviderDialog open={!!provider} provider={provider} onClose={closeDialog} />
    </>
  );
}
